module.exports = __webpack_public_path__ + "static/media/4.66bcc990.jpg";